import React, { useState, useEffect } from "react";
import _ from "lodash";
import ListingTable from "../ListingTable";
import ExportButtons from "../Document/exportButton";
import { useSelector, useDispatch } from "react-redux";
import { getAllTrainFaults } from "../../actions/trainFaults";
import DetailModal from "./DetailModal";
import { cloneDeep } from "lodash";
import { useHistory, useParams } from "react-router";
import { Loader, ModalLoader } from "../Utils/Loader";
import {
  getCustomerFaultsImage,
} from "../../actions/customerFault";
import { setModalLoader } from "../../actions/Header";
import moment from "moment";

const CustomerTrainFaults = ({ modalLoader, searchText, archieveData }) => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [customerTrainFaultList, setCustomerTrainFaultList] = useState([]);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [detailText, setDetailText] = useState("");
  const [selectedRow, setSelectedRow] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const [pageData, setPageData] = useState({
    page: 1,
    pageCount: "",
    searchText,
    columnname: "date_and_time",
    order: "desc",
    tab:
      params.type === "customerfacilityfault"
        ? "cff"
        : params.type === "customertrainfault"
          ? "ctf"
          : "cs",
    is_archive: archieveData.is_archive,
    reportId: archieveData.reportId,
    selectedSortingColumn: "Date & Time"
  });
  const getAllReportData = useSelector((state) => state.reportReducers);

  const getCustomerTrainFaults = useSelector(
    (state) => state.CustomerTrainFaultReduer.CustomerTrainFaults
  );
  const imageUrl = useSelector(
    (state) => state.CustomerStationFaultsReducer.customerFaultImageUrl
  );

  useEffect(() => {
    if (
      getCustomerTrainFaults &&
      Array.isArray(getCustomerTrainFaults.pageData)
    ) {
      let getCustomerTrainFaultsTemp = JSON.parse(
        JSON.stringify(getCustomerTrainFaults.pageData)
      );
      setIsFetching(false);
      setCustomerTrainFaultList(getCustomerTrainFaultsTemp);
      if (getCustomerTrainFaults.pageCount) {
        setPageData({
          ...pageData,
          pageCount: getCustomerTrainFaults.pageCount,
        });
      }
    }
  }, [getCustomerTrainFaults]);

  useEffect(() => {
    let pageDataTemp = cloneDeep(pageData);
    pageDataTemp.searchText = searchText;
    pageDataTemp.is_archive = archieveData.is_archive;
    pageDataTemp.reportId = archieveData.reportId;
    pageDataTemp.page = 1;
    setPageData(pageDataTemp);
    if (Object.keys(getAllReportData.allReports).length > 0 && getAllReportData.allReports.pageData.some(el => el.id === archieveData.reportId) && getAllReportData.allReports.tab == "CTF") {
    setIsFetching(true);
      dispatch(getAllTrainFaults(pageDataTemp))
    }

  }, [searchText, archieveData.reportId, archieveData.is_archive]);

  const getColumns = () => {
    return [
      {
        Header: "Ref_Id",
        accessor: "Ref_Id",
        width: "100",
      },
      {
        Header: "Embarked",
        accessor: "Embarked",
      },
      {
        Header: "Disembarked",
        accessor: "Disembarked",
      },
      {
        Header: "Date & Time",
        Cell: (cellProps) => (
          <span>
            {cellProps.row.original["Date & Time"]
              ? moment(cellProps.row.original["Date & Time"]).format("DD-MM-YYYY HH:mm")
              : ""}
          </span>
        ),
      },
      {
        Header: "Reported",
        Cell: (cellProps) => (
          <span>
            {cellProps.row.original.Reported === 1 ? "true" : "false"}
          </span>
        ),
      },
      {
        Header: "Opted in",
        Cell: (cellProps) => (
          <span>
            {cellProps.row.original["Opted In"] === 1 ? "true" : "false"}
          </span>
        ),
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Email",
        accessor: "Email",
      },
      {
        Header: "Details",
        Cell: (cellProps) => {
          let detailString = cellProps.row.original.Details;
          return (
            <span
              className="text-primary"
              onClick={() => detailTextHandler(detailString)}
            >
              {detailString &&
                detailString.slice(0, 25) +
                (detailString.length > 25 ? "..." : "")}
            </span>
          );
        },
      },
      {
        Header: "Image",
        Cell: (cellProps) =>
          cellProps.row.original["File ID"] ? (
            <span onClick={() => openImageModal(cellProps)}>
              <i className="fa fa-eye"></i>
            </span>
          ) : (
            <React.Fragment />
          ),
      },
      {
        Header: "Status",
        accessor: "Status",
      },
    ];
  };

  const detailTextHandler = (detailsText) => {
    setDetailText(detailsText);
    setIsDetailModalOpen(true);
  };

  const getPageData = (pageData) => {
    setPageData(pageData);
    //setIsFetching(true);
    dispatch(getAllTrainFaults(pageData));
  };

  const onShowDetails = (row) => {
    setSelectedRow(row);
    let id =
      !_.isEmpty(row) && !_.isEmpty(row.original) ? row.original.id : undefined;
      if(id && archieveData.reportId){
    history.push({
      pathname: `/FaultReporter/admin/${params.type}/${id}/${archieveData.reportId}`,
      details: row.original,
    });
  }
  else{
    history.push({
      pathname: `/FaultReporter/admin/customertrainfault/`
    });
  }
  };
  const openImageModal = (cellProps) => {
    let filePath = `Customer Train Faults/${cellProps.row.original.id}/file_${cellProps.row.original["File ID"]}/`;
    dispatch(setModalLoader(true));

    dispatch(getCustomerFaultsImage(filePath));
    setIsImageModalOpen(true);
  };

  const editReportHandler = (id) => {
    history.push(
      `/FaultReporter/admin/reports/${params.type}/add/${archieveData.is_archive == 0 ? "live" : "archive"
      }/${id}`
    );
  };

  const onImageClose = () => {
    dispatch({ type: "GET_CUSTOMER_FAULT_IMAGE_SUCCESS", response: "" });
    setIsImageModalOpen(false);
  };

  return (
    <div>
        <div className="main-body-header-section">
          <h2 className="main-body-heading">
            {searchText ? "Searched Fault Results" : archieveData.reportId
              ? archieveData.selectedReportName
              : "All Faults"}
          </h2>
          {(!searchText && archieveData.reportId) &&
            !(archieveData.selectedReportName === "All Faults") && (
              <button
                className="btn btn-primary btn-icon waves-effect waves-circle waves-float"
                onClick={() => editReportHandler(archieveData.reportId)}
              >
                <i className="zmdi zmdi-edit "></i>
              </button>
            )}
          {customerTrainFaultList.length ? <div className="export-button-groups">
            <ExportButtons isArchive={archieveData.is_archive} />
          </div> : <React.Fragment />}
        </div>
        <div className="listing-table">
          {isFetching ? (
            <Loader />
          ) : customerTrainFaultList.length > 0 ? (
            <ListingTable
              columns={getColumns()}
              data={customerTrainFaultList}
              pageData={pageData}
              getPageData={getPageData}
              // searchText={searchText}
              selectedRow={selectedRow}
              onShowDetails={onShowDetails}
            />
          ) : (
            <div className="fault-history">
              <div className="no-user">
                <i className="zmdi zmdi-block"></i>No faults to display.
              </div>
            </div>
          )}
        </div>

      {isDetailModalOpen && (
        <DetailModal
          modalText={detailText}
          isDetailsModalOpen={setIsDetailModalOpen}
        />
      )}
      {isImageModalOpen && (
        <div
          className="modal d-block modal-background"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="myModalLabel">Fault image</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={onImageClose}
                ><span aria-hidden="true">×</span></button>
              </div>
              <div className="modal-body">
                {modalLoader ? (
                  <ModalLoader />
                ) : (
                  <img
                    alt="The fault submitted is not an image"
                    style={{ height: "100%", width: "100%" }}
                    src={imageUrl}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerTrainFaults;
